import { render, staticRenderFns } from "./Pinterest.vue?vue&type=template&id=b1c5fb00&"
import script from "./Pinterest.vue?vue&type=script&lang=js&"
export * from "./Pinterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pinterest.vue"
export default component.exports